/**
 * The attribution the brief asks for, as a link rather than as a name (module 9). Underlined,
 * because it sits in the same faint grey as the text around it and nothing else would say it is
 * clickable.
 *
 * The `utm_source` tag is part of the address on purpose: it is how the visit is recognised as
 * having come from this app rather than from anywhere else, so it travels with the link instead of
 * being added at whichever call site remembers it.
 */
const APOLLORISE_URL = 'https://apollorise.tech/?utm_source=gftg_event_app';

export function ApolloRiseLink() {
  return (
    <a
      href={APOLLORISE_URL}
      target="_blank"
      rel="noreferrer noopener"
      className="font-semibold text-ink-3 underline"
    >
      ApolloRise
    </a>
  );
}
